import { CatHeading } from '@blocks-react/components/Heading';
import { RequestServiceEquipmentDetailsWrapperProps } from '../types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { capitalizeText } from '../utils';
import styles from '../RequestService.module.scss';

export const RequestServiceEquipmentDetailsWrapper = ({
  equipmentDetail
}: RequestServiceEquipmentDetailsWrapperProps) => {
  const { model, serialNumber, assetName, productFamily, equipmentFamily } =
    equipmentDetail;
  const productFamilyText: string = capitalizeText(
    equipmentFamily ?? productFamily ?? ''
  );
  const equipmentName = `${model} ${productFamilyText}`;
  const nickname = assetName;
  return (
    <>
      {nickname && (
        <CatTooltip position="right" className="d-flex">
          <CatHeading slot="trigger" variant="display-sm">
            <div className={styles['request-service__nickname-wrapper']}>
              {nickname}
            </div>
          </CatHeading>
          <p>{nickname}</p>
        </CatTooltip>
      )}
      <CatTooltip position="right">
        <CatHeading
          slot="trigger"
          variant={!nickname ? 'display-sm' : 'body-sm'}
        >
          <span className="u-color--Black">{equipmentName}</span>
        </CatHeading>
        <p>{equipmentName}</p>
      </CatTooltip>
      <CatHeading variant="body-sm" className="u-color--Black">
        {serialNumber}
      </CatHeading>
    </>
  );
};
